/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Palette_TitleInputs */



/**
* | output |
* | --- |
* | "Search OpenRift" |
*
* @param {Palette_TitleInputs} inputs
* @param {{ locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }} options
* @returns {LocalizedString}
*/
export const palette_title = /** @type {((inputs?: Palette_TitleInputs, options?: { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Palette_TitleInputs, { locale?: "en" | "de" | "fr" | "zh-Hans" | "zh-Hant" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("OpenRift durchsuchen")
	if (locale === "fr") return /** @type {LocalizedString} */ ("Rechercher dans OpenRift")
	if (locale === "zh-Hans") return /** @type {LocalizedString} */ ("搜索 OpenRift")
	if (locale === "zh-Hant") return /** @type {LocalizedString} */ ("搜尋 OpenRift")
	if (locale === "ko") return /** @type {LocalizedString} */ ("OpenRift 검색")
	return /** @type {LocalizedString} */ ("Search OpenRift")
});